import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import CircularProgress from '@mui/material/CircularProgress';
import Box from "@mui/material/Box";

import Page from "../../layout/Page";
import api from "../../service/api";
import { setError } from "../../reducers/appSlice";

const Bold = styled("span")({
  fontWeight: 600,
});

const Perfil = (props) => {
  const dispatch = useDispatch();
  const breadcrumbs = [
    { nombre: "Inicio", ruta: "/" },
    { nombre: "Perfil", ruta: "" },
  ];
  const [usuario, setUsuario] = useState({
    nombre: "",
    email: "",
    organismo: "",
    perfil: "",
  });

  const Box_ = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1, 1, 1, 100),
  }));

  const [submitting, setSubmitting] = useState(true);

  useEffect(() => {
    setSubmitting(true);
    api
      .datosUsuario()
      .then((res) =>
        setUsuario({
          nombre: res.data.apellido + ", " + res.data.nombre,
          email: res.data.email,
          organismoId: res.data.organismo,
          organismo: res.data.organismoDesc,
          perfil: res.data.perfilDesc,
          grupo: res.data.grupo,
          entrada: res.data.entrada,
        })
      )
      .catch((e) => {
        dispatch(setError(e.response.data.error));
      })
      .finally(() => setSubmitting(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Page
        title="DATOS DEL USUARIO"
        breadcrumbs={breadcrumbs}
        disableCheckAuth
      >
        {submitting ? (
          <Box_ align="center">
            <CircularProgress />
          </Box_>

        ) : (
            <>
              <Typography paragraph variant="cuerpo">
                <Bold>Apellido y Nombre</Bold>: {usuario.nombre}{" "}
              </Typography>

              <Typography paragraph variant="cuerpo">
                <Bold>Correo</Bold>: {usuario.email}
              </Typography>

              <Typography paragraph variant="cuerpo">
                <Bold>Organismo</Bold>:{" "}
                {usuario.organismoId != null ? " (COD. " + usuario.organismoId + ")" + usuario.organismo : null}
              </Typography>

              <Typography paragraph variant="cuerpo">
                <Bold>Grupo</Bold>: {usuario.grupo}
                {usuario.entrada ? ". Su organismo está habilitado para enviar expedientes fuera de su grupo de trabajo." : ""}
              </Typography>

              <Typography paragraph variant="cuerpo">
                <Bold>Perfil</Bold>: {usuario.perfil}
              </Typography>
            </>
          )}
      </Page>
    </>
  );
};

export default Perfil;
